import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { key: 1 };
const _hoisted_2 = {
    key: 0,
    class: "notification bulmaNotification is-danger mb-5"
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("strong", null, "Equifax FraudIQ check -", -1);
const _hoisted_4 = { class: "mt-2" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation-circle mx-3" }, null, -1);
const _hoisted_6 = {
    key: 1,
    class: "notification bulmaNotification is-success mb-5"
};
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mx-3" }, null, -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("strong", null, "Equifax FraudIQ check -", -1);
const _hoisted_9 = {
    key: 2,
    class: "notification bulmaNotification is-danger mb-5"
};
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation-circle mx-3" }, null, -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("strong", null, "Equifax Digital Identity Trust recommendation -", -1);
const _hoisted_12 = {
    key: 3,
    class: "notification bulmaNotification is-warning mb-5"
};
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation-triangle mx-3" }, null, -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("strong", null, "Equifax Digital Identity Trust recommendation -", -1);
const _hoisted_15 = {
    key: 4,
    class: "notification bulmaNotification is-success mb-5"
};
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mx-3" }, null, -1);
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("strong", null, "Equifax Digital Identity Trust recommendation -", -1);
import { doApiAction } from '@/core/api';
import { onMounted, ref } from 'vue';
import { apiCitizenChecks } from './api';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CitizenChecksBanner',
    props: {
        citizenId: {},
        checks: {}
    },
    setup(__props) {
        const props = __props;
        const citizenChecks = ref(null);
        onMounted(() => {
            // If 'checks' prop is set, use that value. Otherwise, fetch checks ourselves
            if (props.checks) {
                citizenChecks.value = props.checks;
            }
            else {
                doApiAction(null, null, null, "Failed to load citizen checks", () => {
                    return apiCitizenChecks.getForCitizen(props.citizenId)
                        .then(checks => {
                        citizenChecks.value = checks;
                    });
                });
            }
        });
        return (_ctx, _cache) => {
            var _a, _b, _c;
            const _component_LoadingSpinner = _resolveComponent("LoadingSpinner");
            return (!citizenChecks.value)
                ? (_openBlock(), _createBlock(_component_LoadingSpinner, {
                    key: 0,
                    size: "small"
                }))
                : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (citizenChecks.value.equifaxFraudIq && citizenChecks.value.equifaxFraudIq.alerts.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _hoisted_3,
                            _createTextVNode(" Issues detected "),
                            _createElementVNode("ul", _hoisted_4, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(citizenChecks.value.equifaxFraudIq.alerts, (alert, idx) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: idx,
                                        class: "mt-1"
                                    }, [
                                        _hoisted_5,
                                        _createTextVNode(_toDisplayString(alert), 1)
                                    ]));
                                }), 128))
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (citizenChecks.value.equifaxFraudIq && citizenChecks.value.equifaxFraudIq.alerts.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _hoisted_7,
                            _hoisted_8,
                            _createTextVNode(" SSN verified ")
                        ]))
                        : _createCommentVNode("", true),
                    (((_a = citizenChecks.value.equifaxDigitalIdentityTrust) === null || _a === void 0 ? void 0 : _a.decision) == 'DENY')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _hoisted_10,
                            _hoisted_11,
                            _createTextVNode(" DENY ")
                        ]))
                        : _createCommentVNode("", true),
                    (((_b = citizenChecks.value.equifaxDigitalIdentityTrust) === null || _b === void 0 ? void 0 : _b.decision) == 'REVIEW')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _hoisted_13,
                            _hoisted_14,
                            _createTextVNode(" REVIEW ")
                        ]))
                        : _createCommentVNode("", true),
                    (((_c = citizenChecks.value.equifaxDigitalIdentityTrust) === null || _c === void 0 ? void 0 : _c.decision) == 'APPROVE')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _hoisted_16,
                            _hoisted_17,
                            _createTextVNode(" APPROVE ")
                        ]))
                        : _createCommentVNode("", true)
                ]));
        };
    }
});
